import React from 'react';

import { getSaveHtml } from 'utils';

import './index.scss';

type SafeHtmlProps = {
  htmlContent: string;
};
export const SafeHtml = ({ htmlContent }: SafeHtmlProps) => {
  return <span className="safe-html" dangerouslySetInnerHTML={{ __html: getSaveHtml(htmlContent) }} />;
};

export default SafeHtml;
